import React, { useContext } from 'react';
import "./partners.scss";
import { AppContext } from '../../services/translationContext';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import parse, { domToReact } from 'html-react-parser';
import { useParams } from 'react-router-dom';
import SeoHelmet from '../../components/SeoHelmet';

export const Partners = () => {
  const { lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);
  
  const partnersList = TranslationsService.labels('partners');
  const pageTitle = `${TranslationsService.labels(`our_partners`)} | ${TranslationsService.getMainInfoCompany('name')}`;
  const pageUrl = `https://www.sydea.com/${lang}/about/our-partners`;

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: TranslationsService.labels('our_partners'),
    url: pageUrl
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `https://www.sydea.com/${lang}` },
      { "@type": "ListItem", position: 2, name: TranslationsService.labels(`menu.about.label`), item: `https://www.sydea.com/${lang}/about` },
      { "@type": "ListItem", position: 3, name: TranslationsService.labels('our_partners'), item: pageUrl }
    ]
  };

  const partnersItemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: TranslationsService.labels('our_partners'),
    itemListElement: partnersList.map((partner, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item: {
        "@type": "Organization",
        name: partner.name,
        url: partner.path,
        logo: partner.logo
      }
    }))
  };
  
  const popoverHoverFocus = (textPartner) => (
    <Popover id="popover-trigger-hover-focus">
      <p className='dark-mode-text transition-03s-eio' dangerouslySetInnerHTML={{ __html: textPartner }}></p>
    </Popover>
  );


  const checkIfFirstOrLastTwo = (index) => {
    const elementIndexInRow = index % 4;
    if (elementIndexInRow === 0 || elementIndexInRow === 1) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="section-home light p-5">
      <SeoHelmet
        title={pageTitle}
        description={TranslationsService.labels('our_partners')}
        schema={[webPageSchema, breadcrumbSchema, partnersItemListSchema]}
      />
      <div className='container'>
        <h2 className='syd-title fw-bold'>{TranslationsService.labels('our_partners')}</h2>
        <div className='row g-4'>
          {
            TranslationsService.labels('partners').map((_partner, ind) => (
              <div key={ind} className='col-sm-6 col-lg-3 position-relative'>
                <OverlayTrigger trigger={['hover', 'focus']} placement={checkIfFirstOrLastTwo(ind) ? 'right' : 'left'} overlay={popoverHoverFocus(_partner.text)}>
                  <a href={_partner.path} target='_blank' rel="noreferrer" className='partner-box d-flex align-items-center justify-content-center transition-03s-eio'>
                    <img src={_partner.logo} alt={_partner.name}/>
                  </a>
                  </OverlayTrigger>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};

